import styled from 'styled-components';

import Button from '~/src/common/components/Button';
import { COLORS, SPECIALS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const Container = styled.div`
  --ratio: 1 / 1;
  --thumb-size: 80px;
  --shadow-space: 8px;
  --vertical-gap: 16px;
  --horizontal-gap: 16px;

  display: flex;
  gap: var(--horizontal-gap);

  height: calc(3 * var(--thumb-size) + 2 * var(--vertical-gap));
  ${media.L` height: calc(4 * var(--thumb-size) + 3 * var(--vertical-gap)); `}
`;

export const Thumbnails = styled.div`
  display: none;
  ${media.S` display: flex; `}

  overflow: auto;
  flex: 0 0 auto;
  flex-direction: column;
  gap: var(--vertical-gap) 0;

  > img {
    width: var(--thumb-size);
    height: var(--thumb-size);

    cursor: pointer;
    object-fit: cover;
    border-radius: 4px;
    outline-offset: -2px;
    outline: 2px solid transparent;

    &[aria-current='true'] {
      outline-color: ${COLORS.ACTION_DEFAULT};
    }
  }
`;

export const Carousel = styled.div`
  position: relative;
  overflow: hidden;
  flex: 1 1 1px;
  margin: calc(-1 * var(--shadow-space));
`;

export const Images = styled.div`
  height: 100%;
  display: flex;
  transition: translate 0.4s ease;
  gap: calc(var(--horizontal-gap) - 2 * var(--shadow-space));
`;

export const Image = styled.div`
  height: 100%;
  flex: 0 0 auto;
  position: relative;
  aspect-ratio: var(--ratio);
  padding: var(--shadow-space);

  cursor: zoom-in;

  img,
  &::after {
    border-radius: 4px;
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    box-shadow: ${SPECIALS.SHADOW_NORMAL};
  }

  &::after {
    content: '';
    opacity: 0;
    position: absolute;
    inset: var(--shadow-space);
    transition: opacity 0.2s ease;
    background: ${COLORS.LAYER_OVERLAY};
  }

  &:hover::after {
    opacity: 0.5;
  }
`;

export const Arrow = styled(Button)`
  display: none;
  ${media.M` display: block; `}

  position: absolute;
  translate: 0 -50%;
  top: 50%;

  opacity: 0;
  transition: opacity 0.2s ease;

  &[data-next] {
    right: calc(8px + var(--shadow-space));
  }

  &[data-prev] {
    left: calc(8px + var(--shadow-space));
  }

  ${Carousel}:hover & {
    opacity: 1;
  }
`;
